
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 11 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.145 1.746a.39.39 0 00-.425.354l-.052.568A4.923 4.923 0 005.5.367a4.949 4.949 0 00-4.406 2.712.39.39 0 10.696.355A4.168 4.168 0 015.5 1.148c1.452 0 2.763.757 3.514 1.942l-.557-.398a.39.39 0 00-.454.636l1.69 1.206a.39.39 0 00.615-.282l.19-2.081a.39.39 0 00-.353-.425zM9.735 7.13a.39.39 0 00-.525.17A4.168 4.168 0 015.5 9.585a4.162 4.162 0 01-3.515-1.942l.557.398a.39.39 0 00.454-.636L1.307 6.2a.391.391 0 00-.616.282l-.19 2.08a.39.39 0 10.779.072l.051-.568a4.923 4.923 0 004.169 2.3c1.9 0 3.574-1.084 4.406-2.711a.39.39 0 00-.17-.526z","fill":"#000"}})])
          )
        }
      }
    